import React, {
  useContext,
  useState,
  Dispatch,
  // useMemo,
  useEffect,
} from 'react';
import { UIControlType } from '@sw-sw/lib-form-control-types';
import { ProjectContext } from '../../../contexts/ProjectContext';
// import AppContext from '../../../contexts/AppContext';
// import { useProjectCorrectiveActions } from '../../../hooks/projectDetails';
import FindingCard from '../../Inspections/Findings/FindingCard';
import Loading from '../../Shared/ResourceIndex/Loading';
import {
  FormContext,
  FormSchemaFields,
  FormContextProvider,
} from '@sw-sw/lib-form';
// import { useQuery } from 'react-query';
import Pagination from "react-js-pagination";
import { correctiveActionsFindingsApi } from "../../../utils/api/correctiveActionsFindingsApi";

const controlField = 'findingFilter';

const FindingFilter = (props: {
  handleChange: Dispatch<string>;
  options: { label: string; value: string }[];
}) => {
  const formContext = useContext(FormContext);

  const schema = {
    [controlField]: {
      controlType: UIControlType.select,
      placeholder: 'Finding Types',
      className: 'filter small',
      options: [{ label: 'All Findings', value: 'all' }, ...props.options],
    },
  };

  return (
    <FormSchemaFields
      className='filter-form'
      formData={formContext.value}
      // initialFormData={{ [controlField]: 'all' }}
      onChange={(field, val) => {
        formContext.set(field, val);
        props.handleChange(val);
      }}
      schema={schema}
    />
  );
};

export default function FindingListing(_props: {
  showFindings: string;
  inspectionId: number;
  Finding: string;
}) {
  const projectContext = useContext(ProjectContext);
  // const appContext = useContext(AppContext);

  const [filter, setFilter] = useState<string>('all');
  const [page, setPage] = useState<number>(1);
  const [totalFindingModelCount, setTotalFindingModelCount] = useState<number>(10);
  const [correctiveActionsQuery , setCorrectiveActionsQuery] = useState<any>();
  const [findingFilterOptions , setFindingFilterOptions] = useState<Array<{label: string; value: string;}>>();
  const [perPageDataCount, setperPageDataCount] = useState<number>(10);


  const setPageValue = (pageNumber: number) => {
    setPage(pageNumber);
  }

  const fetchFindings = async () => {
    const projectId: number = projectContext.project ? projectContext.project.id : 0;
    const data: any = await correctiveActionsFindingsApi.index(projectId, filter, page, perPageDataCount);
    setCorrectiveActionsQuery(data);
  }

  const fetchFindingFilterOptions = async () => {
    const projectId: number = projectContext.project? projectContext.project.id : 0;
    const data: any = await correctiveActionsFindingsApi.getFindingFilterOptions(projectId);

    const options = await data.map((_:{type:string})=>_.type).sort().map((type: any) => {
      return {
        label:
          type === 'CA'
            ? 'Corrective Action'
            : type === 'A'
              ? 'Achievement'
              : type === 'MI'
                ? 'Maintenance Item'
                : type,
        value: type,
      };
    });

    setFindingFilterOptions(options);
  }

  const fetchPageModelTotalCount = async () => {
    const projectId: number = projectContext.project ? projectContext.project.id : 0;
    const data: any = await correctiveActionsFindingsApi.getFindingModelPageCount(projectId, filter, page);
    setTotalFindingModelCount(data.total_model_count);
  }

  const onChangePerPageDataCount = async (dataCount: number) => {
    setperPageDataCount(dataCount)
  }

  // const correctiveActionsQuery = useProjectCorrectiveActions(
  //   projectContext.project ? projectContext.project.id : 0, filter, page!
  // );

  // const [filteredFindings, setFilteredFindings] = useState<any[]>(
  //   correctiveActionsQuery || [],
  // );

  useEffect(()=>{
    fetchFindings();
    fetchFindingFilterOptions();
    fetchPageModelTotalCount();
  },[]);

  useEffect(()=>{
    fetchFindings();
  },[page, perPageDataCount]);

  useEffect(()=>{
    fetchFindings();
    fetchPageModelTotalCount();
  },[filter]);

  // useEffect(() => {
  //   if (correctiveActionsQuery) {
  //     // setFilteredFindings(filterFindings(correctiveActionsQuery, filter));
  //     setFilteredFindings(correctiveActionsQuery);
  //     setTotalFindingModelCount(183);
  //   }
  // }, [correctiveActionsQuery, filter]);


  // const filterFindings = (input: any[], filterParam: string) => {
  //   return input.filter((finding: any) => {
  //     if (filter === 'all') {
  //       return true;
  //     }

  //     return finding.type === filterParam;
  //   });
  // };

  // const getOptions = useMemo(() => {
  //   if (!correctiveActionsQuery) return [];

  //   //get all unique types
  //   const uniqueTypes = correctiveActionsQuery.reduce(
  //     (acc: any, finding: any) => {
  //       if (!acc.includes(finding.type)) {
  //         acc.push(finding.type);
  //       }

  //       return acc;
  //     },
  //     [],
  //   );

  //   const options = uniqueTypes.sort().map((type: any) => {
  //     return {
  //       label:
  //         type === 'CA'
  //           ? 'Corrective Action'
  //           : type === 'A'
  //             ? 'Achievement'
  //             : type === 'MI'
  //               ? 'Maintenance Item'
  //               : type,
  //       value: type,
  //     };
  //   });

  //   return options;
  // }, [correctiveActionsQuery]);

  if (!correctiveActionsQuery) {
    return <Loading what='corrective actions' />;
  }

  return (
    <div className='inspection-findings'>
      <div className='right-aligned'>
        <FormContextProvider>
          {(correctiveActionsQuery.length > 0 && findingFilterOptions) && (
            <FindingFilter handleChange={setFilter} options={findingFilterOptions} />
          )}
        </FormContextProvider>
      </div>
      <section className='pure-g findings-listing'>
        {!correctiveActionsQuery.length ? (
          <p className='pure-u'>No findings</p>
        ) : (
          correctiveActionsQuery.map((correctiveActionFinding: any) => (
            <FindingCard
              key={correctiveActionFinding.id}
              finding={correctiveActionFinding}
            />
          ))
        )}
      </section>
      
      <section>  
        <div className='pagination-container'>
          
          <Pagination
            activePage={page}
            itemsCountPerPage={perPageDataCount}
            totalItemsCount={totalFindingModelCount}
            pageRangeDisplayed={4}
            onChange={(e) => setPageValue(e)}
            itemClass="pagination-item"
          />

          {(totalFindingModelCount > 0) ? <select
            value={perPageDataCount}
            onChange={(e) => onChangePerPageDataCount(parseInt(e.target.value))}
            className='pagesize-item'
          >
            {['10', '25', '50'].map((val, index) => {
              return (
                <option key={index} value={val}>
                  {val}
                </option>
              );
            })}
          </select> : null}
        
        </div>
      </section>
    </div>
  );
}
